import { styled } from '@mui/material';

export const Wrap = styled('div')({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
});

export const Header = styled('div')({
	padding: '16px',
});
